import { useState, useRef, useEffect } from "react";
import { Mic, MicOff } from "lucide-react";

const LANG_MAP = {
  en: "en-IN", hi: "hi-IN", gu: "gu-IN", mr: "mr-IN", ta: "ta-IN", te: "te-IN",
  bn: "bn-IN", kn: "kn-IN", pa: "pa-IN", ml: "ml-IN", ur: "ur-IN",
};

/**
 * Voice-to-text button using the browser Web Speech API.
 * Calls onTranscript(text) with the recognised speech.
 */
export const VoiceButton = ({ lang = "en", onTranscript, className = "" }) => {
  const [listening, setListening] = useState(false);
  const recRef = useRef(null);
  const SR = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);

  useEffect(() => () => { try { recRef.current?.stop(); } catch { /* noop */ } }, []);

  const toggle = () => {
    if (!SR) return;
    if (listening) {
      recRef.current?.stop();
      setListening(false);
      return;
    }
    const rec = new SR();
    rec.lang = LANG_MAP[lang] || "en-IN";
    rec.interimResults = false;
    rec.continuous = false;
    rec.onresult = (e) => {
      const t = Array.from(e.results).map((r) => r[0].transcript).join(" ").trim();
      if (t) onTranscript(t);
    };
    rec.onend = () => setListening(false);
    rec.onerror = () => setListening(false);
    recRef.current = rec;
    try { rec.start(); setListening(true); } catch { setListening(false); }
  };

  if (!SR) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="voice-btn"
      data-listening={listening ? "true" : "false"}
      title={listening ? "Listening… tap to stop" : "Tap to speak"}
      className={`${className} ${listening ? "text-green-500 animate-pulse" : "text-red-500 hover:text-red-400"}`}
    >
      {listening ? <Mic className="w-5 h-5" /> : <MicOff className="w-5 h-5" />}
    </button>
  );
};

export default VoiceButton;
